/**
 * Places on Madeira and Porto Santo, offered as a fallback when the browser
 * will not give us a location - which is most of the time on desktop, and
 * always when the visitor has denied it once.
 *
 * Coordinates are the OpenStreetMap centroid of each locality, fetched from
 * Nominatim rather than estimated. They only feed a kilometre-radius filter,
 * so town-centre precision is ample.
 */
export interface Place {
  name: string
  lat: number
  lon: number
}

export const PLACES: Place[] = [
  { name: 'Aeroporto da Madeira', lat: 32.69896, lon: -16.77303 },
  { name: 'Arco da Calheta', lat: 32.7144, lon: -17.14653 },
  { name: 'Calheta', lat: 32.72194, lon: -17.17826 },
  { name: 'Câmara de Lobos', lat: 32.64855, lon: -16.97524 },
  { name: 'Caniçal', lat: 32.7391, lon: -16.73931 },
  { name: 'Caniço', lat: 32.65238, lon: -16.84097 },
  { name: 'Curral das Freiras', lat: 32.72084, lon: -16.96571 },
  { name: 'Estreito de Câmara de Lobos', lat: 32.6711, lon: -16.97997 },
  { name: 'Funchal', lat: 32.64965, lon: -16.90868 },
  { name: 'Garajau', lat: 32.63857, lon: -16.8398 },
  { name: 'Jardim do Mar', lat: 32.73756, lon: -17.21113 },
  { name: 'Machico', lat: 32.72288, lon: -16.76591 },
  { name: 'Monte', lat: 32.67634, lon: -16.90379 },
  { name: 'Ponta do Sol', lat: 32.68124, lon: -17.10408 },
  { name: 'Porto Moniz', lat: 32.86696, lon: -17.16663 },
  { name: 'Ribeira Brava', lat: 32.67009, lon: -17.06504 },
  { name: 'Santa Cruz', lat: 32.68748, lon: -16.79121 },
  { name: 'Santana', lat: 32.80491, lon: -16.8813 },
  { name: 'São Vicente', lat: 32.80228, lon: -17.04724 },
  { name: 'Vila Baleira (Porto Santo)', lat: 33.05931, lon: -16.33366 },
]

/** Accent- and case-insensitive contains, so "canico" finds "Caniço". */
export function matchPlaces(query: string, limit = 6): Place[] {
  const norm = (s: string) =>
    s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  const q = norm(query.trim())
  if (q === '') return PLACES.slice(0, limit)
  const starts = PLACES.filter((p) => norm(p.name).startsWith(q))
  const contains = PLACES.filter((p) => !starts.includes(p) && norm(p.name).includes(q))
  return [...starts, ...contains].slice(0, limit)
}
